export default {
  bookExperiencePanel: "Pannello di prenotazione dell'esperienza",
  calendarIcon: 'Icona del calendario',
  coverImageForResource: 'Immagine di copertina per le esperienze {{title}}',
  filterBy: 'Filtra per {{filter}}',
  filterByDateRange: 'Filtra per intervallo di date',
  gallery: 'Galleria',
  goBack: 'Torna alla pagina precedente',
  hostUserIcon: 'Icona utente host',
  imageOf: 'Immagine di {{title}}',
  interactiveMapAltText: 'Mappa interattiva con selezione di {{title}}',
  mediaSlides: 'Diapositive multimediali',
  muteVideo: 'Disattiva audio video',
  nextPhoto: 'Foto successiva',
  noVideoPlayback: 'Nessuna capacità di riproduzione video',
  pauseVideo: 'Metti in pausa il video',
  photoOf: 'Foto di {{name}}',
  playVideo: 'Riproduci video',
  previousPhoto: 'Foto precedente',
  moreFiltersAndExperiences: 'Altri filtri ed esperienze',
  reserveSelectedSlot: 'Prenota la fascia oraria selezionata',
  reviewRating: 'Valutazione recensione {{rating}} su 5',
  overallReviewRating:
    'Valutazione complessiva delle recensioni {{rating}} su 5',
  selectCountryCodeForPhoneNumber:
    'Seleziona il prefisso internazionale per il numero di telefono',
  selectDate: 'Seleziona la data',
  selectParticipants: 'Seleziona i partecipanti',
  selectSessionTime: "Seleziona l'orario della sessione",
  unmuteVideo: 'Riattiva audio video',
  viewShoppingCart: 'Visualizza il carrello',
  itemsInCart: '{{count}} articoli nel carrello',
  zoomIn: 'Ingrandisci',
  zoomOut: 'Riduci',
  selectData: 'Seleziona {{data}}',
  reserveName: 'Prenota {{name}}',
  deleteReservation: 'Elimina la prenotazione di {{experienceTitle}}',
  editParticipantsFor: 'Modifica partecipanti per {{experienceTitle}}',
  enterPromoCode: 'Inserisci il codice promozionale',
  applyPromoCode: 'Applica codice promozionale',
  increaseAddOnAmount: 'Aumenta {{addOn}} selezionato',
  decreaseAddOnAmount: 'Diminuisci {{addOn}} selezionato',
  addOnModal: '{{addOn}} popup',
  moreInformationAboutAddOn: 'Ulteriori informazioni su {{addOn}}',
  decreasePriceTierTickets: 'Diminuisci i biglietti di {{priceTier}}',
  increasePriceTierTickets: 'Aumenta i biglietti di {{priceTier}}',
  downloadFilename: 'Scarica {{filename}}',
  viewFullDetailsDescription: 'Visualizza la descrizione completa',
  viewFullDescription: 'Visualizza la descrizione completa',
  closeModal: 'Chiudi popup',
  hyattBanner: 'Banner esclusivo per i membri World of Hyatt',
  hyattBannerDesc:
    'Banner promozionale che indica i vantaggi e le offerte esclusive disponibili per i membri del programma fedeltà World of Hyatt',
  previousSlide: 'Slide precedente',
  nextSlide: 'Slide successivo',
  paginationBulletMessage: 'Vai al slide',
  exitFullscreen: 'Esci dal modal completo',
  enterFullscreen: 'Entra nel modal completo',
  videoSlide: 'Slide video',
  imageSlide: 'Slide immagine',
  of: 'di',
  noDescription: 'Nessuna descrizione',
  mediaGallery: 'Carosello - Galleria multimediale',
  dateSelector: 'Selettore data',
  nextWeek: 'Settimana successiva',
  previousWeek: 'Settimana precedente',
  scheduleAgenda: 'Agenda del calendario',
  scheduleNav: 'Navigazione del calendario',
  scheduleViewSelector: 'Selettore vista calendario',
  selectedDateAriaLabel: '{{date}}, selezionato',
  tapToBookExperience: 'Prenota {{title}}',
  bookExperienceAriaLabel: 'Prenota {{title}}',
  joinWaitlistAriaLabel: "Iscriviti alla lista d'attesa per {{title}}",
};
